import { Component, computed, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Store } from '@ngrx/store'
import { VerticalComponent } from '../vertical/vertical.component'
import { TermosCondicoesComponent } from '../termos-condicoes/termos-condicoes.component'
import { TermoConfidencialidadeComponent } from '../termo-confidencialidade/termo-confidencialidade.component'
import { AuthenticatedUserService } from '@/app/core/service/authenticated-user.service'
import { getLayoutState } from '@/app/store/layout/layout-selector'

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [VerticalComponent, TermosCondicoesComponent, TermoConfidencialidadeComponent],
  templateUrl: './layout.component.html',
  styles: ``,
})
export class LayoutComponent {
  private store = inject(Store)
  private authenticatedUser = inject(AuthenticatedUserService)

  readonly mostrarTermos = computed(() => this.authenticatedUser.user()?.leuTermosCondicoes === false)
  readonly mostrarConfidencialidade = computed(() => {
    const usuario = this.authenticatedUser.user()
    return usuario?.leuTermosCondicoes === true && usuario?.leuTermosConfidencialidade === false
  })

  constructor() {
    this.store.select(getLayoutState).pipe(takeUntilDestroyed()).subscribe((layout) => {
      document.documentElement.setAttribute('data-bs-theme', layout.LAYOUT_THEME)
      document.body.setAttribute('data-sidebar-size', layout.MENU_SIZE)
      document.documentElement.setAttribute('data-startbar', layout.STARTBAR_COLOR)
    })
  }
}
